<template>
  <div>
    <div class="searchBox">
      <div class="web">
        <!-- 搜索框 -->
        <search @getList="getList" ref="search" />

        <!-- 省市区 -->
        <div class="province">
          <span
            v-for="(item, index) in provinceList"
            :key="index"
            class="provinceBox"
            :class="item.active?'areaActive':''"
            @click="provinceClick(item,index)"
          >{{item.region_name}}</span>
        </div>
        <div class="city" v-if="cityList.length > 0">
          <span
            v-for="(item, index) in cityList"
            :key="index"
            class="provinceBox"
            :class="item.active?'areaActive':''"
            @click="cityClick(item,index)"
          >{{item.region_name}}</span>
        </div>
        <div class="city" v-if="distList.length > 0">
          <span
            v-for="(item, index) in distList"
            :key="index"
            class="provinceBox"
            :class="item.active?'areaActive':''"
            @click="distClick(item,index)"
          >{{item.region_name}}</span>
        </div>

        <!-- 筛选 -->
        <div class="screen">
          <el-row :gutter="10">
            <!-- 排序 -->
            <el-col :span="3" class="screenBox">
              <el-dropdown @command="sortClick">
                <span class="el-dropdown-link">
                  {{sortList.filter(o=>o.active === searchForm.sort)[0].name}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in sortList"
                    :key="index"
                    :command="item.active"
                  >{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>

            <!-- 机构类型 -->
            <el-col :span="3" class="screenBox">
              <el-dropdown @command="companyTypeClick">
                <span class="el-dropdown-link">
                  {{searchForm.condition.company_type?company_typeList.filter(o=>o.active === searchForm.condition.company_type[0])[0].name:'机构类型'}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                  <i class="el-icon-circle-close" v-if="searchForm.condition.company_type" @click="delSearch('company_type')"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in company_typeList"
                    :key="index"
                    :command="item.active"
                  >{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>

            <!-- 意向职位 -->
            <el-col :span="3" class="screenBox">
              <el-dropdown @command="postClick">
                <span class="el-dropdown-link">
                  {{searchForm.condition.job_name?postList.filter(o=>o === searchForm.condition.job_name)[0]:'意向职位'}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                  <i class="el-icon-circle-close" v-if="searchForm.condition.job_name" @click="delSearch('job_name')"></i>
                </span>
                <el-dropdown-menu slot="dropdown" style="height: 200px;overflow: auto;">
                  <el-dropdown-item
                    v-for="(item, index) in postList"
                    :key="index"
                    :command="item"
                  >{{item}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>

            <!-- 薪资待遇 -->
            <el-col :span="3" class="screenBox">
              <el-dropdown @command="moneyClick">
                <span class="el-dropdown-link" v-if="!searchForm.require.salary_package_min">
                  {{searchForm.require.salary_package_type?moneyList.filter(o=>o.active === searchForm.require.salary_package_type)[0].name:'薪资待遇'}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <span class="el-dropdown-link" v-else>
                  {{moneyText}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" style="height: 200px;overflow: auto;">
                  <el-dropdown-item
                    v-for="(item, index) in moneyList"
                    :key="index"
                    :command="item.active"
                  >{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>

            <!-- 工作经验 -->
            <el-col :span="3" class="screenBox">
              <el-dropdown @command="experienceClick">
                <span class="el-dropdown-link">
                  {{searchForm.require.work_experience?experienceList.filter(o=>o === searchForm.require.work_experience)[0]:'工作经验'}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                  <i class="el-icon-circle-close" v-if="searchForm.require.work_experience" @click="delSearchs('work_experience')"></i>
                </span>
                <el-dropdown-menu slot="dropdown" style="height: 200px;overflow: auto;">
                  <el-dropdown-item
                    v-for="(item, index) in experienceList"
                    :key="index"
                    :command="item"
                  >{{item}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>

            <!-- 学历要求 -->
            <el-col :span="3" class="screenBox">
              <el-dropdown @command="eduClick">
                <span class="el-dropdown-link">
                  {{searchForm.require.educational_require?eduList.filter(o=>o === searchForm.require.educational_require)[0]:'学历要求'}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                  <i class="el-icon-circle-close" v-if="searchForm.require.educational_require" @click="delSearchs('educational_require')"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in eduList"
                    :key="index"
                    :command="item"
                  >{{item}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>

            <!-- 已认证单位 -->
            <el-col :span="3" class="screenBox">
              <el-dropdown @command="verifyClick">
                <span class="el-dropdown-link">
                  已认证单位
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in verifyList"
                    :key="index"
                    :command="item.active"
                  >{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>

            <!-- 优质单位 -->
            <el-col :span="3" class="screenBox">
              <el-dropdown @command="vipClick">
                <span class="el-dropdown-link">
                  优质单位
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in vipList"
                    :key="index"
                    :command="item.active"
                  >{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>

            <el-button type="text" class="reset" @click="resetSearch">清空筛选条件</el-button>
          </el-row>
        </div>
      </div>
    </div>

    <!-- 列表 -->
    <div class="web list" v-loading="loading">
      <el-row :gutter="10">
        <el-col :span="18" v-if="list.length === 0">
          <noData imgWidth="30%" pad="10%" />
        </el-col>
        <el-col :span="18" v-if="list.length > 0">
          <div class="listBox" v-for="(item, index) in list" :key="index" @click="goDetail(item)">
            <div class="clearfix listBoxTop">
              <div class="fl">
                <div>
                  <span class="job_name textOverflow">{{item.job_name}}</span>
                  <span class="area">[{{item.province_name?item.province_name:''}}{{item.city_name?item.city_name:''}}{{item.dist_name?item.dist_name:''}}]</span>
                  <span v-if="item.package_id > 10" class="vipIcon">
                    <img src="http://youpinwang.oss-cn-shenzhen.aliyuncs.com/upload/20220114/dddabccf7ab89d24bba6d87f38191afb.gif" alt="">
                  </span>
                  <img class="exposure" src="http://youpinwang.oss-cn-shenzhen.aliyuncs.com/upload/20220527/0f4823270596dda53795a6be6e00756e.png" alt="" />
                  <span class="exposureText">{{item.exposure}}</span>
                </div>
                <div style="padding-top: 10px;">
                  <span class="salary_package">{{item.salary_package}}{{item.salary_package === '面议'?'':'元/月'}}</span>
                  <el-divider direction="vertical"></el-divider>
                  <span class="educational_require">{{item.educational_require}}</span>
                </div>
              </div>
              <div class="fr">
                <div class="listContent">
                  <div class="school_name">{{item.school_name}}</div>
                  <div class="schoolContent" style="padding-top: 10px;">
                    <span v-if="item.company_type">{{company_typeList[item.company_type - 1].name}}</span>
                    <el-divider v-if="item.company_type" direction="vertical"></el-divider>
                    <span>{{item.person_number}}</span>
                  </div>
                </div>
                <div class="listContent">
                  <el-image style="width: 54px; height: 54px;border-radius: 4px;" :src="item.school_avatar" fit="cover"></el-image>
                </div>
              </div>
            </div>
            <div class="clearfix schoolLabel">
              <div class="fl designation_confim">
                <span v-for="(desItem, desIndex) in item.designation_confim" v-show="desIndex<5" :key="desIndex">{{desItem}}</span>
              </div>
              <div class="fr school_label textOverflow">{{item.school_label}}</div>
            </div>
            <div v-if="item.top_state === 1" class="top_state">
              <img :src="jipin" alt="">
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="Browsed">
            <div class="BrowsedTitle">看过的职位</div>
            <div class="BrowsedList" v-if="BrowsedList.length > 0">
              <div class="BrowsedListBox clearfix" v-for="(item, index) in BrowsedList" :key="index" @click="goSchoolDetail(item)">
                <div class="clearfix">
                  <div class="fl job_name">{{item.job_name}}</div>
                  <div class="fr salary_package">{{item.ideamoney}}{{item.ideamoney === '面议'?'':'元/月'}}</div>
                </div>
                <div class="school_name textOverflow">{{item.school_name}}</div>
              </div>
            </div>
            <div style="padding-bottom: 20px;" v-if="BrowsedList.length === 0">
              <noData imgWidth="70%" pad="10%"  />
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <page :total="total" @getList="getList" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import search from "@/components/search";
import page from "@/components/page";
import noData from "@/components/noData";
import region from "@/js/publicJson";
import { loginState } from "@/js/common.js"
import jipin from '../../assets/jipin.png'

export default {
  components: {
    search,
    page,
    noData
  },
  data() {
    return {
      jipin: jipin,
      loading: true,
      provinceList: region.region,
      cityList: [],
      distList: [],

      //   排序
      sortList: [
        {
          active: "active",
          name: "活跃"
        },
        {
          active: "newest",
          name: "最新"
        },
        {
          active: "distance",
          name: "离我最近"
        },
        {
          active: "compensation",
          name: "薪资从高到低"
        },
        {
          active: "school_chat_reply_rate",
          name: "近90天回复率"
        }
      ],

      //   机构类型
      company_typeList: [
        {
          active: '1',
          name: "幼儿园"
        },
        {
          active: '2',
          name: "早教/托育机构"
        },
        {
          active: '3',
          name: "综合教育公司"
        },
        {
          active: '4',
          name: "其他"
        }
      ],

      postList: [
        "主班老师",
        "乐高老师",
        "书法老师",
        "亲子老师",
        "体育老师",
        "作文老师",
        "保健医生",
        "保安",
        "保教主任",
        "保洁",
        "保育员",
        "其他职位",
        "创客老师",
        "副园长",
        "副班老师",
        "厨师",
        "司机",
        "后勤主任",
        "园长",
        "园长助理",
        "外教老师",
        "实习生",
        "家庭教育老师",
        "幼教老师",
        "感统老师",
        "托育老师",
        "拼音老师",
        "教学主任",
        "数学老师",
        "早教老师",
        "校长",
        "测评师",
        "生活老师",
        "编程老师",
        "美术老师",
        "舞蹈老师",
        "英语老师",
        "蒙氏老师",
        "行政老师",
        "课程营销",
        "课程顾问",
        "速算导师",
        "钢琴老师",
        "音乐老师"
      ],

      // 薪资待遇
      moneyList: [{
        active: '1',
        name: '不限'
      }, {
        active: '2',
        name: '面议'
      }, {
        active: '0-2000',
        name: '2000以下'
      }, {
        active: '2000-3000',
        name: '2000-3000'
      }, {
        active: '3000-4000',
        name: '3000-4000'
      }, {
        active: '4000-5000',
        name: '4000-5000'
      }, {
        active: '5000-6000',
        name: '5000-6000'
      }, {
        active: '6000-7000',
        name: '6000-7000'
      }, {
        active: '7000-8000',
        name: '7000-8000'
      }, {
        active: '8000-9000',
        name: '8000-9000'
      }, {
        active: '9000-10000',
        name: '9000-10000'
      }, {
        active: '10000-11000',
        name: '10000-11000'
      }, {
        active: '11000-12000',
        name: '11000-12000'
      }, {
        active: '12000-13000',
        name: '12000-13000'
      }, {
        active: '13000-14000',
        name: '13000-14000'
      }, {
        active: '14000-15000',
        name: '14000-15000'
      }, {
        active: '15000-9999999',
        name: '15000以上'
      }],

      // 工作经验
      experienceList: ['无经验','一年以内','1-2年','2-4年','4-6年','6-10年','10年以上'],

      // 学历要求
      eduList: ['初中','中专','大专','本科','本科以上'],

      // 已认证单位
      verifyList: [{
        active: '',
        name: '不限'
      }, {
        active: '1',
        name: '是'
      }],

      // 优质单位
      vipList: [{
        active: '',
        name: '不限'
      }, {
        active: '1',
        name: '是'
      }],

      // 筛选form
      total: 0,
      searchForm: {
        area: {},
        page: 1,
        size: 10,
        sort: "active",
        keywords: '',
        condition: {
          company_type: "",
          job_name: "",
          is_verify: '0'
        },
        require: {
          salary_package_type: '',
          salary_package_min: '',
          salary_package_max: '',
          work_experience: '',
          educational_require: ''
        }
      },

      moneyText: '',

      // 职位列表
      list: [],

      // 看过的职位
      BrowsedList: [],

      accToken: ''
    };
  },
  mounted() {
    if(this.Cookies.get('AccessToken')) {
      this.accToken = JSON.parse(this.Cookies.get('AccessToken')).access_token
    }
    setTimeout(() => {
      this.provinceList.forEach(o => {
        o.active = false;
      });
      if(this.$route.query.keywords) {
        this.searchForm.keywords = this.$route.query.keywords
        this.$refs.search.searchVal = this.$route.query.keywords
        this.$router.push({
          query: ''
        })
      }
      try {
        let area = JSON.parse(sessionStorage.getItem('area'))
        if(sessionStorage.getItem('area')) {
          this.provinceList.forEach((o,i)=>{
            if(o.region_id === area.province_id) {
              o.active = true
              this.provinceClick(o, i)
            }
          })
          if(area.city_id) {
            this.cityList.forEach((o, i)=>{
              if(o.region_id === area.city_id) {
                o.active = true
                setTimeout(() => {
                  this.cityClick(o, i)
                }, 500);
              }
            })
          }
        }
      } catch (error) {
        sessionStorage.removeItem('area')
        this.getList()
      }
      this.getBrowsed()
    }, this.accToken?0:1000);
  },
  methods: {

    // 删除搜索
    delSearch(d) {
      this.searchForm.condition[d] = ''
      this.getList()
    },

    // 删除搜索
    delSearchs(d) {
      this.searchForm.require[d] = ''
      this.getList()
    },

    // 去职位详情
    goDetail(o) {
      let routeData = this.$router.resolve({
        path:'/job/postDetail?jid=' + o.jid
      })
      window.open(routeData.href, '_blank');
    },

    // 去园所详情
    goSchoolDetail(o) {
      let routeData = this.$router.resolve({
        path:'/job/schoolDetail?sid=' + o.sid
      })
      window.open(routeData.href, '_blank');
    },

    // 获取看过的职位
    getBrowsed() {
      if(loginState()) {
        let obj = {
          from: 'C',
          page: 1,
          size: 8
        }
        this.api.get('/5cf0a0e863113', obj).then(r => {
          this.BrowsedList = r.data.list
        })
      }
    },

    // 请求列表
    getList(page, keyWord) {
      console.log(this.searchForm.area)
      if(page) {
        this.searchForm.page = page
      } else {
        this.searchForm.page = 1
      }
      if(keyWord) {
        this.searchForm.keywords = keyWord
      }
      let obj = this.searchForm
      obj = JSON.parse(JSON.stringify(obj))
      obj.require.educational_require = [this.searchForm.require.educational_require]
      this.loading = true
      this.api.post('/5cefadba19924', obj).then(r => {
        this.list = r.data.list
        this.total = r.data.count
        sessionStorage.setItem('area', JSON.stringify(this.searchForm.area))
        this.list.forEach(o=>{
          if(o.designation_confim) {
            o.designation_confim = JSON.parse(o.designation_confim)
          }
          if(o.school_label.length > 0) {
            o.school_label = o.school_label.join('，')
          } else {
            o.school_label = ''
          }
          try {
            o.educational_require = JSON.parse(o.educational_require)[0]
          } catch (error) {
            o.educational_require = o.educational_require
          }
        })
        this.loading = false
      })
    },

    //   省点击
    provinceClick(o, i) {
      this.cityList = o.children;
      this.provinceList.forEach(o => {
        o.active = false;
      });
      o.active = true;
      this.searchForm.area.province_id = o.region_id
      this.searchForm.area.provice_name = o.region_name
      this.searchForm.area.city_id = ''
      this.searchForm.area.city_name = ''
      this.searchForm.area.dist_id = ''
      this.searchForm.area.dist_name = ''
      this.distList = []
      this.getList()
    },

    //   市点击
    cityClick(o, i) {
      this.distList = o.children;
      this.cityList.forEach(o => {
        o.active = false;
      });
      o.active = true;
      this.searchForm.area.city_id = o.region_id
      this.searchForm.area.city_name = o.region_name
      this.searchForm.area.dist_id = ''
      this.searchForm.area.dist_name = ''
      this.getList()
    },

    // 区点击
    distClick(o, i) {
      this.distList.forEach(o => {
        o.active = false;
      });
      o.active = true;
      this.distList = JSON.parse(JSON.stringify(this.distList))
      this.searchForm.area.dist_id = o.region_id
      this.searchForm.area.dist_name = o.region_name
      this.getList()
    },

    // 排序筛选
    sortClick(e) {
      this.searchForm.sort = e;
      this.getList()
    },

    // 机构类型筛选
    companyTypeClick(e) {
      this.searchForm.condition.company_type = [e];
      this.getList()
    },

    // 意向职位筛选
    postClick(e) {
      this.searchForm.condition.job_name = e;
      this.getList()
    },

    // 薪资选择
    moneyClick(e) {
      if(e === '1' || e === '2') {
        this.searchForm.require.salary_package_type = e;
        this.searchForm.require.salary_package_min = ''
        this.searchForm.require.salary_package_max = ''
      } else {
        this.searchForm.require.salary_package_type = '3';
        if(e === '0-2000') {
          this.moneyText = '2000以下'
        } else if (e === '15000-9999999') {
          this.moneyText = '15000以上'
        } else {
          this.moneyText = e
        }

        let arr = e.split('-')
        this.searchForm.require.salary_package_min = arr[0]
        this.searchForm.require.salary_package_max = arr[1]
      }
      this.getList()
    },

    // 工作经验
    experienceClick(e) {
      this.searchForm.require.work_experience = e;
      this.getList()
    },

    // 学历要求
    eduClick(e) {
      this.searchForm.require.educational_require = e;
      this.getList()
    },

    // 已认证单位
    verifyClick(e) {
      this.searchForm.condition.is_verify = e;
      this.getList()
    },

    // 优质单位
    vipClick(e) {
      this.searchForm.condition.is_vip = e;
      this.getList()
    },

    // 清空筛选条件
    resetSearch() {
      this.searchForm = {
        area: this.searchForm.area,
        sort: "active",
        keywords: '',
        condition: {
          company_type: "",
          job_name: "",
          is_verify: '0'
        },
        require: {
          salary_package_type: '',
          salary_package_min: '',
          salary_package_max: '',
          work_experience: '',
          educational_require: ''
        }
      }
      this.$refs.search.searchVal = ''
      this.getList()
    }
  }
};
</script>

<style lang="scss" scoped>
.searchBox {
  padding-top: 32px;
  background: #fff;
  box-shadow: 0 3px 6px rgba(6, 0, 1, 0.05);
  .provinceBox {
    padding: 0 11px;
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
    margin-top: 10px;
  }
  .province {
    padding-bottom: 10px;
  }
  .areaActive {
    color: #ff5b12;
  }
  .city {
    border-top: 1px solid #eef0f5;
    padding-bottom: 10px;
  }
  .screen {
    border-top: 1px solid #eef0f5;
    padding: 10px 0;
    position: relative;
    .screenBox {
      text-align: center;
      .el-dropdown-link {
        cursor: pointer;
      }
    }
    .reset {
      position: absolute;
      right: -86px;
      top: -10px;
    }
  }
}

.list {
  .listBox:nth-child(1) {
    margin-top: 30px;
  }
  .listBox {
    background: white;
    margin-top: 10px;
    cursor: pointer;
    position: relative;
    .top_state {
      position: absolute;
      right: 0;
      bottom: 0;
      img {
        width: 50px;
        height: 50px;
      }
    }
    .listBoxTop {
      padding: 20px 30px;
      .vipIcon img {
        width: 30px;
        height: 30px;
        vertical-align: middle;
      }
    }
    .job_name {
      max-width: 117px;
      display: inline-block;
      vertical-align: middle;
    }
    .area {
      color: #FF5B12;
      margin-left: 10px;
    }
    .salary_package {
      color: #fc703e;
    }
    .educational_require {
      color: #61687c;
      font-size: 14px;
    }
    .listContent {
      display: inline-block;
      vertical-align: middle;
      .school_name {
        color: #fc703e;
      }
      .schoolContent {
        font-size: 14px;
        color: #61687c;
      }
    }
    .listContent:nth-child(2) {
      margin-left: 46px;
    }
  }
}
.schoolLabel {
  background: #f8f9fc;
  padding: 10px 30px;
  .designation_confim {
    >span {
      border: 1px solid #eee;
      border-radius: 2px;
      margin-right: 10px;
      color: #61687c;
      font-size: 12px;
      height: 21px;
      line-height: 21px;
      display: inline-block;
      padding: 0 8px;
    }
  }
  .school_label {
    font-size: 12px;
    color: #61687c;
    max-width: 350px;
  }
}

.Browsed {
  background: white;
  margin-top: 30px;
  .BrowsedTitle {
    color: #fc703e;
    padding: 15px 30px;
    font-size: 15px;
    border-bottom: solid 2px #f2f2f5;
  }
  .BrowsedList {
    padding: 0 30px;
    .BrowsedListBox:hover {
      .job_name {
        color: #fc703e;
      }
    }
    .BrowsedListBox:last-child {
      border-bottom: none;
    }
    .BrowsedListBox {
      cursor: pointer;
      border-bottom: solid 1px #eef0f5;
      padding: 10px 0;
      .salary_package {
        color: #fc703e;
        font-size: 14px;
        text-align: right;
      }
      .job_name {
        font-size: 14px;
      }
      .school_name {
        color: #8d92a1;
        font-size: 12px;
        padding-top: 5px;
        width: 100%;
      }
    }
  }
}

.exposure {
  width: 15px;
  vertical-align: middle;
  margin-left: 10px;
}

.exposureText {
  color: #FF5B12;
  vertical-align: middle;
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/pages/job/post.vue